import { baseToApiShape, baseFromApiShape, baseInitNewForm, baseInitEditForm } from '../formHelpers/base';

/**
 * Oracle-specific flat → nested API payload.
 * Extends base with: Flex instances (OCPU/mem), availability domain, VCN networking,
 * marketplace OCIDs, disk types.
 */
export function toApiShape(form) {
    const base = baseToApiShape(form);

    return {
        ...base,
        info: {
            ...base.info,
            prefix: form.prefix || '',
            server_ocid: form.serverOcid || null,
            node_ocid: form.nodeOcid || null,
            unifiedImageId: form.unifiedImageId || null,
        },
        data: {
            ...base.data,
            LPG: form.lpg || '',
            vcn_cidr: form.vcnCidr || '',
            local_cidr: form.localCidr || '',
            packages: form.packages || [],
            server: {
                ...base.data.server,
                disk_type: form.serverDiskType || '',
                ocpus: form.serverOcpus || 1,
                mem: form.serverMem || 1,
            },
            network: {
                ...base.data.network,
                availability_domain: form.availabilityDomain || '',
                vcn_id: form.vcnId || '',
                security_group_id: form.securityGroupId || '',
            },
            node: {
                ...base.data.node,
                disk_type: form.nodeDiskType || '',
            },
        },
    };
}

/**
 * Oracle-specific nested → flat form state.
 */
export function fromApiShape(cluster) {
    return {
        ...baseFromApiShape(cluster),

        prefix: cluster.info?.prefix || '',
        serverOcid: cluster.info?.server_ocid || null,
        nodeOcid: cluster.info?.node_ocid || null,
        unifiedImageId: cluster.info?.unifiedImageId || null,

        serverDiskType: cluster.data?.server?.disk_type || '',
        serverOcpus: cluster.data?.server?.ocpus || 1,
        serverMem: cluster.data?.server?.mem || 1,

        nodeDiskType: cluster.data?.node?.disk_type || '',

        availabilityDomain: cluster.data?.network?.availability_domain || '',
        vcnId: cluster.data?.network?.vcn_id || '',
        securityGroupId: cluster.data?.network?.security_group_id || '',

        lpg: cluster.data?.LPG || '',
        vcnCidr: cluster.data?.vcn_cidr || '',
        localCidr: cluster.data?.local_cidr || '',
        packages: cluster.data?.packages || [],
    };
}

export function initNewForm(provider, config) {
    return {
        ...baseInitNewForm(provider, config),
        serverDiskType: '',
        nodeDiskType: '',
        serverOcpus: 1,
        serverMem: 1,
        packages: [],
        // Marketplace OCIDs
        serverOcid: config.marketplaceConfig?.server_ocid || null,
        nodeOcid: config.marketplaceConfig?.node_ocid || null,
    };
}

export function initEditForm(cluster, config) {
    return {
        ...baseInitEditForm(cluster, config),

        prefix: cluster.info?.prefix || '',
        serverOcid: cluster.info?.server_ocid || null,
        nodeOcid: cluster.info?.node_ocid || null,
        unifiedImageId: cluster.info?.unifiedImageId || null,

        serverDiskType: cluster.data?.server?.disk_type || '',
        serverOcpus: cluster.data?.server?.ocpus || 1,
        serverMem: cluster.data?.server?.mem || 1,
        nodeDiskType: cluster.data?.node?.disk_type || '',

        availabilityDomain: cluster.data?.network?.availability_domain || '',
        vcnId: cluster.data?.network?.vcn_id || '',
        securityGroupId: cluster.data?.network?.security_group_id || '',

        lpg: cluster.data?.LPG || '',
        vcnCidr: cluster.data?.vcn_cidr || '',
        localCidr: cluster.data?.local_cidr || '',
        packages: cluster.data?.packages || [],
    };
}

/** Returns true if instance supports configurable OCPU/memory */
export function isFlexInstance(instanceId) {
    return Boolean(instanceId && instanceId.includes('Flex'));
}
